import { App, createApp, getCurrentInstance } from 'vue';
import KKConfirm from './index.vue';
import { IConfirmOptions } from './typings';
import { ComponentPublicInstance } from '@vue/runtime-core';

export function confirm(options: IConfirmOptions): ComponentPublicInstance {
  const currentInstance = getCurrentInstance();
  let instance: ComponentPublicInstance | null = null;
  const component = createApp(KKConfirm, {
    ...options,
    modelValue: true,
    zIndex: 1000,
    ['onUpdate:modelValue'](val: boolean) {
      if (instance?.$) {
        instance.$.props.modelValue = val;
      }
    },
    onClose() {
      // 关闭弹窗后，自助销毁
      component.unmount();
    },
    onConfirm() {
      if (typeof options?.onConfirm === 'function') {
        options?.onConfirm();
      }
    },
    onCancel() {
      if (typeof options?.onCancel === 'function') {
        options?.onCancel();
      }
    },
    onClickButton(index: number) {
      if (typeof options?.onClickButton === 'function') {
        options?.onClickButton(index);
      }
    },
  });
  Object.assign(component._context, currentInstance?.appContext);
  const el = document.createElement('div');
  instance = component.mount(el);
  return instance;
}

export default function install(app: App) {
  // eslint-disable-next-line no-param-reassign
  app.config.globalProperties.$confirm = confirm;
}
